export const LOGIN = 'login'; // 1 day

export const ClusterEnv = 'ClusterEnv';
export const TourCustomPageValue = 'TourCustomPageValue';

export enum InterestedOptions {
  Workforce_Planning = 'Workforce planning',
  Workforce_Intelligence = 'Workforce intelligence',
  Compensation_Strategy = 'Compensation strategy',
  Talent_Acquisition = 'talentacquisition', // this cookie is used in an e2e test
  Competitive_Benchmarking = 'Competitive benchmarking',
  Data_Enrichment_and_Custom_Reports = 'Data enrichment & custom reports', // this cookie is used in an e2e test
  Data_Feed = 'Data feed',
  Academic_Research = 'academicresearch',
  Investment_Management = 'investmentmanagement',
  Workforce_Planning_and_Analytics = 'workforceplanninganalytics',
  Talent_Intelligence = 'talentintelligence',
  Product_Management = 'productmanagement',
}

export enum PageTitles {
  COMPANY = 'Company',
  INDUSTRY = 'Industry',
  SUMMARY = 'Overview',
  SENTIMENT = 'Sentiment',
  GEOGRAPHY = 'Geography',
  ROLE = 'Role',
  SKILL = 'Skill',
  ACTIVITY = 'Activity',
  COMPOSITIONS = 'Compositions',
  TRANSITIONS = 'Transitions',
  JOB_POSTINGS = 'Job Postings',

  SCREENER = 'Discovery',
  TALENT_DISCOVERY = 'Discovery',
  POSTING_DISCOVERY = 'Postings',
  RESUME_ENRICHMENT = 'Resume Enrichment',
  DOCUMENTATION = 'Documentation',
  INDIVIDUAL = 'Individual',
  FEEDBACK = 'Submit Bug / Feature Request',
  TRIAL_EXPIRED = 'Trial Expired',
  DELIVERABLES = 'Data',
  DATA_BUILDER = 'Data Builder',
  DELIVERABLES_STATUS = 'Delivery Status',
  PAY = 'Pay',
  REPORTS = 'Your Reports',
  REPORTS_STATUS = 'Reports Status',
  REPORTS_SAMPLE = 'Sample Report',
  DATA_ENRICHMENT = 'Data Enrichment',
  REPORT_BUILDER = 'Report Builder',
  HEALTH_CHECK = 'Health Check',
  CUSTOM_DASH = 'Custom Dash',

  /** Top-level sidebar sections (feature-flagged dashboard layout) */
  DASHBOARD_NAV = 'Dashboards',
  DISCOVERY_NAV = 'Discovery',
  REPORTS_NAV = 'Reports',
  APPLICATIONS_NAV = 'Tools',
  ECONOMIC_IMPACT = 'Economic Impact',
}

export enum Views {
  SUMMARY = 'summary',
  OVERVIEW = 'overview',
  TRANSITION = 'transition',
  POSTING = 'posting',
  COMPENSATION = 'compensation',
  ENTITY_SUMMARY = 'entity_summary',
  SENTIMENT = 'sentiment',
  SENTIMENT_RATING = 'sentiment_rating',
  SENTIMENT_EFFECT = 'sentiment_score',
  SENTIMENT_REVIEW = 'sentiment_review',
  TALENT_DISCOVERY = 'talent_discovery',
  SCREENER = 'screener',
  NONE = '',
}

export enum PagePaths {
  LANDING = '/',

  COMPANY_SUMMARY = 'company/summary',
  COMPANY_COMPOSITIONS = 'company/compositions',
  COMPANY_POSTINGS = 'company/postings',
  COMPANY_TRANSITIONS = 'company/transitions',
  COMPANY_PAY = 'company/pay',
  COMPANY_DIVERSITY = 'company/diversity',
  COMPANY_SENTIMENT = 'company/sentiment',
  COMPANY_SUBSIDIARIES = 'company/subsidiaries',
  COMPANY_SCREENER = 'company/screener',
  COMPANY_COMPOSITIONS_LEGACY = 'company/composition',
  COMPANY_SENTIMENT_RATINGS_LEGACY = 'company/sentiment-ratings',
  COMPANY_SENTIMENT_REVIEWS_LEGACY = 'company/sentiment-reviews',

  INDUSTRY_COMPOSITIONS = 'industry/compositions',
  INDUSTRY_POSTINGS = 'industry/postings',
  INDUSTRY_TRANSITIONS = 'industry/transitions',
  INDUSTRY_PAY = 'industry/pay',
  INDUSTRY_MARKET_CONDITIONS = 'industry/market-conditions',
  INDUSTRY_SENTIMENT = 'industry/sentiment',

  GEOGRAPHY_SUMMARY = 'geography/summary',
  GEOGRAPHY_COMPOSITIONS = 'geography/compositions',
  GEOGRAPHY_POSTINGS = 'geography/postings',
  GEOGRAPHY_TRANSITIONS = 'geography/transitions',
  GEOGRAPHY_PAY = 'geography/pay',
  GEOGRAPHY_MARKET_CONDITIONS = 'geography/market-conditions',
  GEOGRAPHY_SENTIMENT = 'geography/sentiment',
  GEOGRAPHY_SCREENER = 'geography/screener',
  GEOGRAPHY_COMPOSITIONS_LEGACY = 'geography/composition',
  GEOGRAPHY_SENTIMENT_RATINGS_LEGACY = 'geography/sentiment-ratings',
  GEOGRAPHY_SENTIMENT_REVIEWS_LEGACY = 'geography/sentiment-reviews',

  ROLE_SUMMARY = 'role/summary',
  ROLE_COMPOSITIONS = 'role/compositions',
  ROLE_POSTINGS = 'role/postings',
  ROLE_TRANSITIONS = 'role/transitions',
  ROLE_PAY = 'role/pay',
  ROLE_MARKET_CONDITIONS = 'role/market-conditions',
  ROLE_SENTIMENT = 'role/sentiment',
  ROLE_SCREENER = 'role/screener',
  ROLE_COMPOSITIONS_LEGACY = 'role/composition',
  ROLE_SENTIMENT_RATINGS_LEGACY = 'role/sentiment-ratings',
  ROLE_SENTIMENT_REVIEWS_LEGACY = 'role/sentiment-reviews',

  // Skill unit of analysis: no overview, transitions, screener or sentiment
  // page (sentiment has no skill support).
  SKILL_COMPOSITIONS = 'skill/compositions',
  SKILL_POSTINGS = 'skill/postings',
  SKILL_PAY = 'skill/pay',
  SKILL_MARKET_CONDITIONS = 'skill/market-conditions',

  // Activity unit of analysis: the same four views as skill.
  ACTIVITY_COMPOSITIONS = 'activity/compositions',
  ACTIVITY_POSTINGS = 'activity/postings',
  ACTIVITY_PAY = 'activity/pay',
  ACTIVITY_MARKET_CONDITIONS = 'activity/market-conditions',

  DELIVERABLES = 'deliverables',
  DATA_BUILDER = 'data-builder',
  DATA_BUILDER_STATUS = 'data-builder-status',
  DATA_BUILDER_SHARE = 'data-builder-share',
  RESUME_ENRICHMENT = 'resume-enrichment',
  REPORTS = 'reports',
  REPORTS_SAMPLE = 'sample-report',
  DATA_ENRICHMENT = 'data-enrichment',
  REPORT_BUILDER = 'report-builder',
  TALENT_DISCOVERY = 'talent-discovery',
  POSTING_DISCOVERY = 'posting-discovery',
  TAXONOMY_CATALOG = 'taxonomy-catalog',
  DATA_DICTIONARY = 'data-dictionary',
  HEALTH_CHECK = 'health-check',
  CUSTOM_DASHBOARD = 'custom-dash',
}

export enum TourClasses {
  TOUR_TRACKING_CLASS = 'rl_tour_tracking',
  TOUR_FILTER_MENU_CLASS = 'rl_tour_filter_menu_class',
  TOUR_VIEW_CLASS = 'rl_tour_view',
  TOUR_ANALYTICS_VIEW_TABS_CLASS = 'rl_tour_analytics_view_tabs',
}

export const FLAG_ENABLE_RICS = true;
